'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ACCOUNT_SID = 'accountSid';
var AUTH_TOKEN = 'authToken';
var FROM_PHONE_NUMBER = 'fromPhoneNumber';
var schema = {
  id: 'twilio',
  name: 'Twilio',
  keys: {
    ACCOUNT_SID: ACCOUNT_SID,
    AUTH_TOKEN: AUTH_TOKEN,
    FROM_PHONE_NUMBER: FROM_PHONE_NUMBER
  },
  requiredKeys: [ACCOUNT_SID, AUTH_TOKEN, FROM_PHONE_NUMBER],
  spec: [{
    key: ACCOUNT_SID,
    value: ''
  }, {
    key: AUTH_TOKEN,
    private: true,
    value: ''
  }, {
    key: FROM_PHONE_NUMBER,
    value: ''
  }]
};
exports.default = {
  schema: schema
};